import React from 'react'

const GoogleTerms = () => {
  return (
    <div className='ml-auto mr-auto flex items-center justify-center md:mt-0 mt-[10px]'>
      <p className="text-center w-[70%] text-[12px] md:text-[16px]">
        By clicking{" "}
        <span class="angled-brackets">
          &lt;&lt; Continue with Google &gt;&gt;
        </span>
        , you agree to our{" "}
        <a href="https://policies.google.com/terms" target="_blank">
          Terms,
        </a>{" "}
        <a href="https://policies.google.com/privacy" target="_blank">
          Privacy Policy and &nbsp;
        </a>
        <a href="refund_policy.html" target="_blank">
          Refund
        </a>{" "}
        and{" "}
        <a href="cancellation_policy.html" target="_blank">
          Cancellation Policy
        </a>
        .
      </p>
    </div>
  )
}

export default GoogleTerms;
